import _size from "lodash/size";
import _isNil from "lodash/isNil";
import FastqFileType from 'const/enums/FastqFileType';
import createMemoizedSelector from '../createMemoizedSelector';
import getPairs from './getPairs';

// eslint-disable-next-line no-unused-vars
var getPairMatchesAreValid = function getPairMatchesAreValid(secondaryAnalysisId) {
  return function (analysisState, pairs) {
    if (_isNil(analysisState) || _isNil(pairs)) return false;
    var files = analysisState.files,
      numOfSublibraries = analysisState.numOfSublibraries;
    var pairMatches = files.pairMatches,
      filesData = files.data;
    if (filesData === null) return false;
    var wtPairsSize = _size(pairs[FastqFileType.WT_FASTQ]);
    var immunePairsSize = _size(pairs[FastqFileType.IMMUNE_FASTQ]);
    return wtPairsSize === immunePairsSize && wtPairsSize === _size(pairMatches) && numOfSublibraries === wtPairsSize;
  };
};
export default createMemoizedSelector(getPairMatchesAreValid, {
  inputSelectors: [{
    func: function func(secondaryAnalysisId) {
      return function (state) {
        return state[secondaryAnalysisId];
      };
    },
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }, {
    func: getPairs,
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }]
});